import apiClient, { plainApiClient } from "..";
import { alphanumeric_unique } from "../../utils/functions";

const AUTH_ROUTE_CLIENT_GENERATE_OTP = "/auth/generateOTP";
const AUTH_ROUTE_CLIENT_VERIFY_OTP = "/auth/verifyOTP";
const AUTH_ROUTE_LIASON_GENERATE_OTP = "/auth/generateOTPForLaisonOfficer";
const AUTH_ROUTE_LIASON_VERIFY_OTP = "/auth/verifyOTPForLaisonOfficer";
const AUTH_ROUTE_EMPLOYEE_LOGIN = "/auth/faLogin";
const UPLOAD_PROFILE = "/userProfilePics";
const AUTH_GET_PUBLIC_KEY = "/GetPublickey";

export const clientGenerateOtp = (panNo) => {
  return apiClient.post(AUTH_ROUTE_CLIENT_GENERATE_OTP, {
    PanNo: panNo,
  });
};

export const clientVerifyOtp = ({ otp, sessionId, PanNo, IsPoint }) => {
  return apiClient.post(AUTH_ROUTE_CLIENT_VERIFY_OTP, {
    Otp: otp,
    sessionId,
    PanNo,
    IsPoint,
    DeviceId: alphanumeric_unique(),
  });
};

export const liasionGenerateOtp = ({ MobileNo, EmailId }) => {
  return apiClient.post(AUTH_ROUTE_LIASON_GENERATE_OTP, {
    MobileNo,
    EmailId,
  });
};

export const uploadProfileHook = (file, path) => {
  let formData = new FormData();
  formData.append("image", file.file);

  return plainApiClient.post(
    path !== undefined ? path : UPLOAD_PROFILE,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        isform: true,
      },
    }
  );
};

export const liasionVerifyOtp = ({
  MobileNo,
  Otp,
  SessionId,
  EmailId,
  IsPoint,
}) => {
  return apiClient.post(AUTH_ROUTE_LIASON_VERIFY_OTP, {
    MobileNo,
    Otp,
    SessionId,
    EmailId,
    IsPoint,
  });
};

export const employeeLogin = ({ UserName, Password }) => {
  return apiClient.post(AUTH_ROUTE_EMPLOYEE_LOGIN, {
    UserName,
    Password,
  });
};

export const getAuthPublicKey = () => {
  return plainApiClient.get(AUTH_GET_PUBLIC_KEY);
};
